import { Navigate } from 'react-router-dom';
import { endpoints } from '@/api/endpoints';
import { useApi } from '@/api/useApi';
import { LoadingState } from '@/components/EmptyState';
import { ErrorBanner } from '@/components/ErrorBanner';
import { useT } from '@/i18n/LanguageContext';

/**
 * `/shipments/:id` used to be the card of a PHYSICAL shipment; it is now the card of the order. An old link (bookmark, a
 * dashboard "incomplete shipment" problem) carries a shipment id, which the order lookup does not know: resolve it to its order
 * and open that card. If it is not a shipment either, show the original "not found".
 */
export function LegacyShipmentRedirect({ id, notFound, onRetry }: { id: string; notFound: unknown; onRetry: () => void }): JSX.Element {
  const t = useT();
  const shipment = useApi(() => endpoints.shipment(id), [id]);
  if (shipment.status === 'loading') return <LoadingState label={t('shipments.card.legacyLooking')} />;
  if (shipment.status === 'success') {
    const orderId = shipment.data.shipment.sales_order_id;
    if (typeof orderId === 'string' && orderId !== '') return <Navigate to={`/shipments/${orderId}`} replace />;
  }
  return <ErrorBanner error={notFound} onRetry={onRetry} />;
}
